import { LedgerView } from "./LedgerView";

export function RefundsPage() {
  return (
    <LedgerView
      title="Refunds"
      helperText="Every refund issued — currently generated automatically when a withdrawal is rejected (see Withdrawals). Each one is a real, separate ledger entry, never an edit to the original debit."
      fixedReasons={["refund"]}
    />
  );
}
